import _ from 'lodash';

export default function archiveItems(preEdit, postEdit, defaults = {}) {
  return _(preEdit)
    .differenceBy(postEdit, 'id')
    .map(item => _.assign({ id: item.id, status: 'Archived' }, defaults))
    .concat(postEdit)
    .value();
}



// WEBPACK FOOTER //
// ./app/utils/archive-items.js